import React, { useEffect } from 'react';

import { useBeam } from "@randajan/bifrost/client/react";
import { LoginButton } from "./LoginButton/LoginButton"
import { ProfileButton } from "./ProfileButton/ProfileButton"
import { docsBeam, userBeam } from "../../config/bifrost";
import { usePop } from '@randajan/jet-react/dom/modal';
import { InitScreen } from './InitScreen/InitScreen';
import { Medailon } from './Medailon/Medailon';




export const Account = () => {
    const { data: user } = useBeam(userBeam);

    const initPop = usePop({ lock: true });

    useEffect(_ => {
        if (!user) { initPop.down(); return; }
        const { consentTerms, consentGdpr, consentNotify } = user;
        if (consentTerms && consentGdpr && consentNotify != null) { initPop.down(); return; }
        initPop.up(<InitScreen onFinish={_=>initPop.down()}/>);
    }, [user]);

    return user ? <ProfileButton><Medailon {...user}/></ProfileButton> : <LoginButton />;
}